/**
 * Publicidad solo en vistas digitales. PDFs clínicos/familiares/recetas: sin anuncios.
 * Banners deben usar <a href={link} target="_blank" rel="noopener noreferrer">.
 */

export const ALLOWED_AD_PLACEMENTS = [
  { value: "landing_home", label: "Landing · bloque principal" },
  { value: "landing_mid", label: "Landing · sección media" },
  { value: "login_bottom", label: "Login · pie del formulario" },
  { value: "dashboard_top", label: "Panel · parte superior" },
  { value: "dashboard_side", label: "Panel · lateral" },
];

/** Solo referencia documental; el backend/API debe rechazar estos valores. */
export const FORBIDDEN_PDF_OR_REPORT_PLACEMENTS = [
  "pdf",
  "pdf_footer",
  "pdf_header",
  "clinical_report",
  "family_report",
  "prescription",
  "recipe",
];

export function isAllowedAdPlacement(value) {
  if (!value || typeof value !== "string") return false;
  return ALLOWED_AD_PLACEMENTS.some((p) => p.value === value);
}
